var cantidad_minima = null;
selectSuministro = function(){
    let suministro = $("#select_toma_suministro option:selected")[0];
    if(suministro){
        console.log(suministro.dataset);
        $("#cantidad_suministro").val(suministro.dataset.cantidad);
        cantidad_minima = parseFloat(suministro.dataset.cantidad_minima);
        $("#btn_toma_suministros").attr('disabled',false);
        $("#cantidad_tomar").attr('disabled',false).attr('placeholder',"Introduce la cantidad");
    }else{
        cantidad_minima = null;
        $("#btn_toma_suministros").attr('disabled',true);
        $("#cantidad_tomar").attr('disabled',true).attr('placeholder',"Selecciona el suministro");
    }
}

validarTomaSuministro = function(e){
    let actual = $("#cantidad_suministro").val();
    let cantidad = e.value;
    let html = "";
    if(actual!=="" && cantidad!==""){
        let restante = parseFloat(actual) - parseFloat(cantidad);
        if(cantidad_minima!==null){
            if(restante<=0)
                html =
                    `<div class="alert alert-danger text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> Al tomar esta cantidad el inventario de este suministro será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
            else if(restante<cantidad_minima)
                html =
                    `<div class="alert alert-warning text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> La cantidad mínima en inventario de este suministro es de <strong>${cantidad_minima}</strong>, al tomar esta cantidad el inventario de éste será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
        }
        $("#div_info_suministro").html(html);
    }
}